import { AxiosError, type AxiosResponse, type InternalAxiosRequestConfig } from 'axios'
import sendLog from '../../sendLog'
import { getAxiosErrorStatusCode } from '../api.utils'

// Axios Response formatter "borrowed" from - https://github.com/tylerlong/axios-formatter/blob/master/src/index.ts
const responseFormatter = (response: AxiosResponse): string => `HTTP ${response.status} ${
  response.statusText
}${response.data.message ? ` - ${response.data.message}` : ''}
  Response:
  ${JSON.stringify(
    {
      data: response.data,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
    },
    null,
    2
  )}
  Request:
  ${JSON.stringify(
    {
      method: response.config.method,
      baseURL: response.config.baseURL,
      url: response.config.url,
      params: response.config.params,
      data: response.config.data,
      headers: response.config.headers,
    },
    null,
    2
  )}`

const logRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  sendLog(`Request: sent ${config.method?.toUpperCase()} request to ${config.baseURL}${config.url}`)

  return config
}

const logResponseInterceptor = (response: AxiosResponse) => {
  sendLog(
    `Response: success received ${response.status} from ${response.config.baseURL}${response.config.url}`
  )

  return response
}

const logErrorInterceptor = (error: AxiosError) => {
  sendLog(responseFormatter(error.response as AxiosResponse))
  return Promise.reject(error)
}

const logErrorCheckStatusInterceptor = (error: AxiosError) => {
  const errorStatus = getAxiosErrorStatusCode(error)
  if (![401, 403, 404].includes(errorStatus)) {
    sendLog(`Axios: failed to receive response with status ${errorStatus}`)
  }

  return Promise.reject(error)
}

export {
  logRequestInterceptor,
  logResponseInterceptor,
  logErrorInterceptor,
  logErrorCheckStatusInterceptor,
  responseFormatter,
}
